module.exports = __webpack_public_path__ + "static/media/supveto4.26990042.png";